// extracted by mini-css-extract-plugin
export default {"wrapper":"Media-module__wrapper___UV+Nu","slide-in":"Media-module__slide-in___vCzLE","animateOut":"Media-module__animateOut___x7O7+","slide-out":"Media-module__slide-out___1xGNj"};